import dayjs from "dayjs"

/**
 * The conversation list's timestamp: today's messages show a clock, this
 * week's a weekday, older ones a date. dayjs's `calendar` plugin is not
 * registered in this app, and registering one globally for a single list is a
 * bigger change than the three cases it would cover.
 */
export const conversationTimestamp = (
  value: string | null,
  now = dayjs()
): string => {
  if (!value) return ""
  const moment = dayjs(value)
  if (moment.isSame(now, "day")) return moment.format("h:mm A")
  if (moment.isSame(now.subtract(1, "day"), "day")) return "Yesterday"
  if (now.diff(moment, "day") < 7) return moment.format("ddd")
  return moment.format("MMM D")
}

/** The date separator between days in a message history. */
export const dayDivider = (value: string, now = dayjs()): string => {
  const moment = dayjs(value)
  if (moment.isSame(now, "day")) return `Today, ${moment.format("MMM D")}`
  if (moment.isSame(now.subtract(1, "day"), "day")) {
    return `Yesterday, ${moment.format("MMM D")}`
  }
  return moment.format("dddd, MMM D")
}
